export default __webpack_public_path__ + "static/warnings-ed4749a8144c1abe418e9d11e342a2cd.png";